export { default } from "./PhenotypeCarousel";
